module.exports = __webpack_public_path__ + "static/img/PayPalLogoGrigio.d7bc371.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/PayPalLogoGrigio.png
// module id = Pv8E
// module chunks = 1